import $ from 'jquery';
import _ from 'underscore';
import Slideshow from 'picnic/slideshow/views/Slideshow';


class View extends Slideshow {

	render() {
		super.render();
		this._lazyResize = _.debounce(this._onResize, 10);
		$(window).on('resize orientationChange', () => this._lazyResize());
		return this;
	}

	/**
	 * Reinit slideshow after resize
	 */
	_onResize() {
		const windowWidth = window.innerWidth || $(window).width();
		if (windowWidth < this.options.breakpoint && this.slideshow && this.slideshow.unslicked) {
			this.slideshow.reinit();
		}
	}

}

export default View;
